// extracted by mini-css-extract-plugin
export default {"container":"TermsOfService_container__XLOtp","chatLinkButton":"TermsOfService_chatLinkButton__okIT1"};